import React, { Component } from 'react';
import { connect } from 'react-redux';
import NativeSelect from '@material-ui/core/NativeSelect';

import Grid from "./Grid";
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
// import * as MonthlyMoney from './Saga/MonthlyMoney';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';
import * as CashTeller from './Saga/CashTellers';
import { CSVLink, CSVDownload } from 'react-csv';
import { ExportToCsv } from 'export-to-csv';

import Button from '@material-ui/core/Button';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CsvModal from "./csv_modal";

var moment = require('moment-timezone');

interface Props {
    section: any,
    shops: any,
    in: any,
    out: any,
    cash_tellers_list: any,
    GetList: any,
    cash_tellers_monthly_insert: any,
    SelectSection: any,
    selectedDate: any,
    user_id: any,
    cash_teller_monthly: any,
    cash_teller_nowmonthly: any,
    cash_tellers_monthly_delete: any

}



interface State {
    refresh: boolean,
    modalcontract: boolean,
}


var payment_in = 0;
var payment_out = 0;

var payment_in_day = 0;
var payment_out_day = 0;

var section_check = false;
var keiri_check = false;


const options = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalSeparator: '.',
    useTextFile: false,
    useBom: false,
    useKeysAsHeaders: false,
    // headers: ['Coslumn 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
};

const csvExporter = new ExportToCsv(options);


class Cashteller extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            refresh: false,
            modalcontract: false,
        }
        this.confirm = this.confirm.bind(this);
        this.delete = this.delete.bind(this);
        this.csv = this.csv.bind(this);

        this.toggle = this.toggle.bind(this);

    }


    toggle() {

        this.setState(prevState => ({
            modalcontract: !prevState.modalcontract,
        }));
        return;
    }





    componentWillMount() {

    }

    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        return
    }

    confirm() {

        var money = 0;
        if (this.props.cash_teller_monthly[0]) {
            money = this.props.cash_teller_monthly[0].payment_result;
            this.props.cash_tellers_list.forEach((value: any) => {
                money = money + value.payment;
            });

        }

        var data = {
            section_id: this.props.SelectSection,
            confirm_date: this.props.selectedDate,
            payment_result: money,
            created_at: new Date(),
            created_user: this.props.user_id
        };

        this.props.cash_tellers_monthly_insert(data);
        alert("この月の出納が確定されました");
        this.props.GetList();
    }

    delete() {
        var result = window.confirm('月次確定を取り消します。宜しいですか？');
        if (result) {
            var data = {
                section_id: this.props.SelectSection,
                confirm_date: this.props.selectedDate,
            };

            this.props.cash_tellers_monthly_delete(data);
            alert("確定が削除されました")
            this.props.GetList();
        }
    }

    print() {
        window.print();
    }

    csv() {
        csvExporter.generateCsv(this.props.cash_tellers_list[0]["CSVdata"]);
    }

    render() {




        // this.props.cash_tellers_list;

        return (
            <div className="row">

                <i style={{
                    fontSize: "25px"
                }} className="fas fa-print" onClick={this.print}></i>

                {(() => {
                    if (this.props.cash_tellers_list[0]) {
                        // return <CSVLink style={{ marginLeft: "23px" }} data={this.props.cash_tellers_list[0]["CSVdata"]} enclosingCharacter={``}>
                        //     <i style={{ fontSize: "23px" }} className="fas fa-file-csv"></i>
                        // </CSVLink>
                        return <i style={{ fontSize: "23px", marginLeft: "23px" }} className="fas fa-file-csv" onClick={this.toggle}></i>
                    } else {
                        return "";
                    }
                })()}

                <button style={{
                    fontSize: "18px", marginLeft: "auto"
                }} className="btn btn-sm btn-info" onClick={this.props.GetList}>
                    更新
      </button>
                <div style={{
                    fontSize: "25px"
                }} className="item-outer col-lg-9">

                    <table style={{ border: "solid" }}>
                        <tr style={{ border: "solid" }}>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>支払者チェック</th>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>経理チェック</th>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>入金(累計)　　</th>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>出金(累計)　　</th>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>入金(本日チェック分)</th>
                            <th style={{ fontWeight: 'normal', border: "solid", textAlign: "center" }}>出金(本日チェック分)</th>
                        </tr>
                        <tr>

                            {(() => {
                                if (this.props.cash_tellers_list[0]) {
                                    // 全てにチェックを付けているかどうかのフラグ
                                    section_check = true;
                                    keiri_check = true;

                                    // 合計額用
                                    payment_in = 0;
                                    payment_out = 0;

                                    // 今日チェックした分の合計用
                                    payment_in_day = 0;
                                    payment_out_day = 0;

                                    this.props.cash_tellers_list.forEach((value: any) => {

                                        //　チェックが入っていなかったらfalse
                                        if (value.section_check_user == null) {
                                            section_check = false;
                                        }
                                        if (value.keiri_check_user == null) {
                                            keiri_check = false;
                                        }

                                        // マイナスだったら出金　プラスなら入金
                                        if (value.payment > 0) {
                                            payment_in = payment_in + value.payment;
                                        } else {
                                            payment_out = payment_out + value.payment;
                                        }


                                        // 今日チェックした分のみ合計 経理とその他の部署で分ける
                                        if (this.props.section == 10 || this.props.section == 8 || this.props.section == 30 || this.props.section == 32) {

                                            var now = new Date();
                                            var date = moment(value.keiri_check_at).format('YYYY-MM-DD');
                                            var date2 = moment(now).format('YYYY-MM-DD');
                                            if (date == date2) {
                                                if (value.payment > 0) {
                                                    payment_in_day = payment_in_day + value.payment;
                                                } else {
                                                    payment_out_day = payment_out_day + value.payment;
                                                }
                                            }

                                        } else {

                                            var now = new Date();
                                            var date = moment(value.section_check_at).format('YYYY-MM-DD');
                                            var date2 = moment(now).format('YYYY-MM-DD');
                                            if (date == date2) {
                                                if (value.payment > 0) {
                                                    payment_in_day = payment_in_day + value.payment;
                                                } else {
                                                    payment_out_day = payment_out_day + value.payment;
                                                }
                                            }
                                        }
                                    });
                                    payment_out = payment_out - payment_out - payment_out;
                                    payment_out_day = payment_out_day - payment_out_day - payment_out_day;

                                } else {
                                    payment_in = 0;
                                    payment_out = 0;
                                    payment_in_day = 0;
                                    payment_out_day = 0;
                                }
                            })()}

                            {(() => {
                                if (section_check == true) {
                                    return <td style={{ border: "solid", textAlign: "center", backgroundColor: "#add8e6" }}>
                                        完了
                            </td>
                                } else {
                                    return <td style={{ border: "solid", textAlign: "center", backgroundColor: "#ff69b4" }}>
                                        未完了
                            </td>
                                }
                            })()}
                            {(() => {
                                if (keiri_check == true) {
                                    return <td style={{ border: "solid", textAlign: "center", backgroundColor: "#add8e6" }}>
                                        完了
                            </td>
                                } else {
                                    return <td style={{ border: "solid", textAlign: "center", backgroundColor: "#ff69b4" }}>
                                        未完了
                            </td>
                                }
                            })()}

                            <td style={{ border: "solid", textAlign: "right" }}>{payment_in}</td>
                            <td style={{ border: "solid", textAlign: "right" }}>{payment_out}</td>
                            <td style={{ border: "solid", textAlign: "right" }}>{payment_in_day}</td>
                            <td style={{ border: "solid", textAlign: "right" }}>{payment_out_day}</td>
                        </tr>
                    </table>
                </div>

                {(() => {
                    if (this.props.section == 10 || this.props.section == 8 || this.props.section == 30 || this.props.section == 32) {
                        if (this.props.cash_teller_nowmonthly[0]) {
                            return <button className="btn btn btn-danger" style={{ margin: "5px", marginRight: 50 }} onClick={this.delete} >確定解除</button>
                        } else {
                            return <button className="btn btn btn-success" style={{ margin: "5px", marginRight: 50 }} onClick={this.confirm} >月次確定</button>
                        }
                    } else {
                        return ""
                    }
                })()}




                <CsvModal
                    modalcontract={this.state.modalcontract}
                    toggle={this.toggle}
                    GetList={this.props.GetList}
                />
            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        shops: state.masterReducer.shops,
        cash_teller_monthly: state.CashTeller.cash_teller_monthly,
        cash_teller_nowmonthly: state.CashTeller.cash_teller_nowmonthly,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        cash_tellers_monthly_insert(state: any) {
            dispatch(CashTeller.cash_tellers_monthly_insert(state))
        },
        cash_tellers_monthly_delete(state: any) {
            dispatch(CashTeller.cash_tellers_monthly_delete(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




